<script>
import axios from "axios";
import modalLlStudent from "./modal-ll-student.vue";
import creditHistoryModal from "./credit-history-modal.vue";
import {toast} from "vue3-toastify";
export default {
  name: "student-dashboard",
  components: { modalLlStudent, creditHistoryModal },
  props: ['student', 'lessons', 'llLessons'],
  data() {
    return {
      user_id: null,
      current_student: null,
      orders: [],
      loadingOrders: false,
      selectedCurrency: 'CZK',
      selectedCountry: 'CZ',
      currencies: [
        { code: 'CZK', label: 'Kč (CZK)', country: 'CZ' },
        { code: 'EUR', label: '€ (EUR)', country: 'SK' }
      ],
      countries: [
        { code: 'CZ', label: 'Česko', vat: 21 },
        { code: 'SK', label: 'Slovensko', vat: 23 }
      ]
    };
  },
  mounted() {
    this.loadOrders();
  },
  computed: {
    student_id() {
      return this.student ? this.student.id : null;
    },
    hasNoCredits() {
      return this.student && this.student.ll_credit_sum === 0;
    },
    hasLowCredits() {
      return this.student && this.student.ll_credit_sum > 0 && this.student.ll_credit_sum < 4;
    },
    pastLessons() {
      const now = new Date();
      return this.lessons.filter(lesson => new Date(lesson.when) < now);
    },
    nextLesson() {
      const now = new Date();

      const futureLessons = this.lessons.filter(lesson => new Date(lesson.next_lesson) >= now);
      return futureLessons.length > 0 ? futureLessons[0] : null;
    }
  },
  methods: {
    studentUpdated() {


    },
    handleStudentProfil() {
      axios.get(`/conversation_club/students/me`).then(response => {
        this.current_student = response.data.student
        this.$refs.studentDetail.showModal()
      })
    },
    handleStudentLessons() {
      window.location.href = `/students/${this.student_id}/lessons`;
    },
    handleLogout() {
      window.location.href = `/logout`;
    },
    formatDate(dateString) {
      const date = new Date(dateString);
      return date.toLocaleDateString('cs-CZ', {
        year: 'numeric',
        month: 'long',
        day: 'numeric'
      });
    },
    formatTime(dateString) {
      const date = new Date(dateString);
      return date.toLocaleTimeString('cs-CZ', {
        hour: '2-digit',
        minute: '2-digit'
      });
    },
    getLectorName(lesson) {
      return lesson.lecturer ? `${lesson.lecturer.first_name} ${lesson.lecturer.last_name}` : 'Neznámý lektor';
    },
    onCurrencyChange() {
      // Auto-select country based on currency
      const selected = this.currencies.find(c => c.code === this.selectedCurrency);
      if (selected) {
        this.selectedCountry = selected.country;
      }
    },
    openEshop(){
      const token = this.student?.eshop_token || '';
      const currency = this.selectedCurrency;
      const country = this.selectedCountry;
      window.location.href = `/objednavka?brand=oj&language=cs&source=ll&id=1179&type=0&token=${token}&currency=${currency}&country=${country}`
    },
    openCreditHistory() {
      this.$refs.creditHistoryModal.open();
    },
    async loadOrders() {
      this.loadingOrders = true;
      try {
        const response = await axios.get('/ll/home/my_orders.json');
        this.orders = response.data.orders;
      } catch (error) {
        console.error('Chyba při načítání objednávek:', error);
      } finally {
        this.loadingOrders = false;
      }
    },
    formatCurrency(amount, symbol) {
      return `${Math.round(amount)} ${symbol}`;
    },
    formatOrderDate(dateString) {
      const date = new Date(dateString);
      return date.toLocaleDateString('cs-CZ', {
        year: 'numeric',
        month: 'numeric',
        day: 'numeric'
      });
    },
    retryPayment(order) {
      const data = {
        order_id: order.id
      };
      axios.post('/shopping_cart/retry_payment', data).then((response) => {
        this.payment_id = response.data.payment.id;
        this.paymentSessionId = response.data.gopay_payment_session_id;
        this.encryptedSignature = response.data.encrypted_signature;
        const url = response.data.gopay_url
        if (url) {
          //this.ga_add_payment_info()
          window.location.href = url;
        }
      }).catch((error) => {
        console.log(error);
        toast('Chyba při vytváření objednávky - ' + error.response.data.error, {type: 'error'});
      });
    },
    downloadInvoice(order) {
      if (order.invoice_token) {
        window.open(`/inv/${order.invoice_token}`, '_blank');
      }
    },
    getStatusClass(status) {
      const statusClasses = {
        completed: 'badge bg-success',
        pending: 'badge bg-warning text-dark',
        cancelled: 'badge bg-secondary',
        failed: 'badge bg-danger',
        refunded: 'badge bg-info',
        processing: 'badge bg-primary',
        unpaid: 'badge bg-secondary'
      };
      return statusClasses[status] || 'badge bg-secondary';
    }

  }
}
</script>

<template>

  <modal-ll-student ref="studentDetail" :student="current_student" :admin="false" @userUpdated="studentUpdated"/>
  <credit-history-modal ref="creditHistoryModal" :student-id="student_id"/>

  <div class="cc-calendar">
    <div class="top-button-group" >
        <div v-if="student_id">
            <a :href="`https://student.onlinejazyky.cz?token=${this.student.eshop_token}`" target="_blank" class="btn btn-light">studovna</a>
            <button class="btn btn-public mr-2" @click.prevent="handleStudentProfil">Profil</button>

            <button class="btn btn-small mr-2" @click.prevent="handleLogout">Odhlásit</button>
        </div>

        <div v-if="!student_id && !user_id">
            <a href="/login" class="btn btn-public" >Přihlásit se</a>
        </div>
    </div>
  </div>




  <div class="container mt-4">
    
    <!-- Currency Selection - Always Visible -->
    <div class="card mb-4 shadow-sm">
      <div class="card-body py-3">
        <div class="row align-items-center">
          <div class="col-md-8">
            <h6 class="mb-0">
              <i class="fas fa-coins"></i> Nastavení měny pro nákup kreditů
            </h6>
            <small class="text-muted">Zvolte měnu, ve které chcete nakupovat kredity (země a DPH se nastaví automaticky)</small>
          </div>
          <div class="col-md-4">
            <div class="currency-selector-compact">
              <label class="selector-label">Měna:</label>
              <select v-model="selectedCurrency" @change="onCurrencyChange" class="form-select">
                <option v-for="curr in currencies" :key="curr.code" :value="curr.code">
                  {{ curr.label }}
                </option>
              </select>
              <small class="text-muted ms-2">
                <span v-if="selectedCurrency === 'CZK'">🇨🇿 Česko (lekce osvobozeny od DPH)</span>
                <span v-else-if="selectedCurrency === 'EUR'">🇸🇰 Slovensko (DPH 23%)</span>
              </small>
            </div>
          </div>
        </div>
      </div>
    </div>
    
    <!-- Výrazný banner když má student 0 kreditů -->
    <div v-if="hasNoCredits && (student.memberships==null || student.memberships.length == 0)" class="alert alert-danger credit-alert-zero mb-4" role="alert">
      <div class="row align-items-center">
        <div class="col-md-8">
          <h3 class="mb-2">
            ⚠️ Nemáte žádné kredity na lekce
          </h3>
          <p class="mb-0">
            Pro pokračování ve výuce si prosím zakupte kredity. Můžete si vybrat balíček 4, 8, 10 nebo 20 lekcí.
          </p>
        </div>
        <div class="col-md-4 text-end">
          <button @click.prevent="openEshop" class="btn btn-buy-credits-large">
            🛒 Koupit kredity
          </button>
        </div>
      </div>
    </div>

    <!-- Varování pro nízký počet kreditů (1-3) -->
    <div v-else-if="hasLowCredits" class="alert alert-warning credit-alert-low mb-4" role="alert">
      <div class="row align-items-center">
        <div class="col-md-8">
          <h5 class="mb-1">
            ⚡ Zbývá vám pouze 
            <span class="credit-link" @click="openCreditHistory" title="Klikněte pro zobrazení historie kreditů">
              {{student.ll_credit_sum}} {{ student.ll_credit_sum === 1 ? 'kredit' : (student.ll_credit_sum < 5 ? 'kredity' : 'kreditů') }}
            </span>
          </h5>
          <p class="mb-0 small">Doporučujeme dokoupit další lekce, abyste mohli pokračovat ve výuce bez přerušení.</p>
        </div>
        <div class="col-md-4 text-end">
          <button @click.prevent="openEshop" class="btn btn-buy-credits-medium">
            ➕ Dokoupit lekce
          </button>
        </div>
      </div>
    </div>

    <!-- Příští lekce -->
    <div class="card mb-4" v-if="nextLesson">
      <div class="card-body">
        <div class="row align-items-center">
          <div class="col-md-8">
            <h5 class="mb-2">
              📅 Příští lekce
            </h5>
            <p class="mb-1">
              <strong>{{ formatDate(nextLesson.next_lesson) }}</strong> v {{ formatTime(nextLesson.next_lesson) }}
            </p>
            <p class="mb-0">
              <strong>Lektor:</strong> {{ getLectorName(nextLesson) }}
            </p>
          </div>
          <div class="col-md-4 text-end">
            <div class="credit-display mb-2">
              <span class="credit-link" @click="openCreditHistory" title="Klikněte pro zobrazení historie kreditů">
                💳 {{student.ll_credit_sum}} {{ student.ll_credit_sum === 1 ? 'kredit' : (student.ll_credit_sum < 5 ? 'kredity' : 'kreditů') }}
              </span>
            </div>
            <button @click.prevent="openEshop" class="btn btn-buy-credits-small">
              ➕ Dokoupit lekce
            </button>
          </div>
        </div>
      </div>
    </div>

    <!-- Info box když student nemá naplánovány žádné lekce ale má kredity -->
    <div v-if="!nextLesson && !hasNoCredits" class="card mb-4 border-info">
      <div class="card-body">
        <div class="row align-items-center">
          <div class="col-md-8">
            <h5 class="mb-2">
              ℹ️ Nemáte naplánovány žádné lekce
            </h5>
            <p class="mb-0">
              Máte 
              <span class="credit-link" @click="openCreditHistory" title="Klikněte pro zobrazení historie kreditů">
                💳 {{student.ll_credit_sum}} {{ student.ll_credit_sum === 1 ? 'kredit' : (student.ll_credit_sum < 5 ? 'kredity' : 'kreditů') }}
              </span>
              k dispozici. Kontaktujte svého lektora pro naplánování další lekce.
            </p>
          </div>
          <div class="col-md-4 text-end">
            <button @click.prevent="openEshop" class="btn btn-buy-credits-small">
              ➕ Dokoupit lekce
            </button>
          </div>
        </div>
      </div>
    </div>

    <!-- Karta výuky když student nemá žádné lesson instances ale má ll_lesson -->
    <div v-if="!nextLesson && llLessons && llLessons.length > 0" class="card mb-4">
      <div class="card-header bg-primary text-white">
        <h5 class="mb-0">👨‍🏫 Vaše výuka</h5>
      </div>
      <div class="card-body">
        <div v-for="llLesson in llLessons" :key="llLesson.id" class="mb-3 pb-3 border-bottom">
          <div class="row">
            <div class="col-md-6">
              <p class="mb-2">
                <strong>Lektor:</strong> 
                {{ llLesson.lector ? `${llLesson.lector.first_name} ${llLesson.lector.last_name}` : 'Nepřiřazen' }}
              </p>
              <p class="mb-2" v-if="llLesson.b_type==`b2b`" >
                <strong>Typ lekce:</strong> {{ llLesson.lesson_type_name }}
              </p>
            </div>
            <div class="col-md-6">
              <p class="mb-2">
                <strong>Délka lekce:</strong> {{ llLesson.minutes }} minut
              </p>
              <p class="mb-2">
                <strong>Kredity:</strong> 
                <span class="credit-link" @click="openCreditHistory" title="Klikněte pro zobrazení historie kreditů">
                  💳 {{ llLesson.credit }} {{ llLesson.credit === 1 ? 'kredit' : (llLesson.credit < 5 ? 'kredity' : 'kreditů') }}
                </span>
              </p>
            </div>
          </div>
        </div>
        <div class="alert alert-info mb-0 mt-2">
          <small>
            💡 Kontaktujte svého lektora pro naplánování první lekce. 
            Pokud potřebujete více kreditů, můžete si je 
            <a href="#" @click.prevent="openEshop" class="alert-link">dokoupit zde</a>.
          </small>
        </div>
      </div>
    </div>

    <!-- Moje objednávky -->
    <div class="card mb-4">
      <div class="card-header bg-info text-white">
        <h5 class="mb-0">🛒 Moje objednávky</h5>
      </div>
      <div class="card-body">
        <div v-if="loadingOrders" class="text-center py-4">
          <div class="spinner-border" role="status">
            <span class="sr-only">Načítání...</span>
          </div>
        </div>
        <div v-else-if="orders.length === 0" class="text-muted text-center py-4">
          Zatím nemáte žádné objednávky
        </div>
        <div v-else>
          <!-- Desktop: Tabulka (≥992px) -->
          <div class="table-responsive d-none d-lg-block">
            <table class="table table-hover">
              <thead>
                <tr>
                  <th>Číslo</th>
                  <th>Datum</th>
                  <th>Produkt</th>
                  <th>Částka</th>
                  <th>Stav</th>
                  <th>Akce</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="order in orders" :key="order.id">
                  <td><strong>#{{ order.order_number }}</strong></td>
                  <td>{{ formatOrderDate(order.created_at) }}</td>
                  <td>{{ order.product_description }}</td>
                  <td><strong>{{ formatCurrency(order.total, order.currency_symbol) }}</strong></td>
                  <td>
                    <span :class="getStatusClass(order.status)">
                      {{ order.status_text }}
                    </span>
                  </td>
                  <td>
                    <!-- Tlačítko pro zaplacené objednávky - stáhnout fakturu -->
                    <button 
                      v-if="order.status === 'completed' && order.invoice_token" 
                      @click="downloadInvoice(order)" 
                      class="btn btn-sm btn-success"
                      title="Stáhnout fakturu">
                      📄 Faktura
                    </button>
                    
                    <!-- Tlačítko pro nezaplacené objednávky - zopakovat platbu -->
                    <button 
                      v-else-if="order.can_retry_payment" 
                      @click="retryPayment(order)" 
                      class="btn btn-sm btn-warning"
                      title="Zopakovat platbu">
                      💳 Zaplatit
                    </button>
                    
                    <!-- Pro pending objednávky -->
                    <span v-else-if="order.status === 'pending'" class="text-muted small">
                      Čeká se na platbu
                    </span>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>

          <!-- Mobile/Tablet: Cards (<992px) -->
          <div class="responsive-cards d-lg-none">
            <div v-for="order in orders" :key="order.id" class="responsive-card">
              <div class="card-header">
                <strong>#{{ order.order_number }}</strong>
                <span :class="getStatusClass(order.status)">
                  {{ order.status_text }}
                </span>
              </div>
              <div class="card-body">
                <div class="info-row">
                  <div class="label">Datum:</div>
                  <div class="value">{{ formatOrderDate(order.created_at) }}</div>
                </div>
                <div class="info-row">
                  <div class="label">Produkt:</div>
                  <div class="value">{{ order.product_description }}</div>
                </div>
                <div class="info-row">
                  <div class="label">Částka:</div>
                  <div class="value"><strong>{{ formatCurrency(order.total, order.currency_symbol) }}</strong></div>
                </div>
                <div class="info-row">
                  <div class="label">Akce:</div>
                  <div class="value">
                    <!-- Tlačítko pro zaplacené objednávky - stáhnout fakturu -->
                    <button 
                      v-if="order.status === 'completed' && order.invoice_token" 
                      @click="downloadInvoice(order)" 
                      class="btn btn-sm btn-success"
                      title="Stáhnout fakturu">
                      📄 Faktura
                    </button>
                    
                    <!-- Tlačítko pro nezaplacené objednávky - zopakovat platbu -->
                    <button 
                      v-else-if="order.can_retry_payment" 
                      @click="retryPayment(order)" 
                      class="btn btn-sm btn-warning"
                      title="Zopakovat platbu">
                      💳 Zaplatit
                    </button>
                    
                    <!-- Pro pending objednávky -->
                    <span v-else-if="order.status === 'pending'" class="text-muted small">
                      Čeká se na platbu
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Historie lekcí -->
    <div class="card">
      <div class="card-header bg-secondary text-white">
        <h3>Historie lekcí</h3>
      </div>
      <div class="card-body">
        <div v-if="pastLessons.length === 0" class="text-muted">
          Zatím jste neměli žádné lekce
        </div>
        <div v-else>
          <div v-for="lesson in pastLessons" :key="lesson.id" class="lesson-item border-bottom py-3">
            <div class="row">
              <div class="col-md-3">
                <strong>{{ formatDate(lesson.when) }}</strong><br>
                <small>{{ formatTime(lesson.when) }}</small>
              </div>
              <div class="col-md-3">
                <strong>Lektor:</strong><br>
                {{ getLectorName(lesson) }}
              </div>
              <div class="col-md-6">
                <strong>Téma lekce:</strong><br>
                {{ lesson.lesson_topic || 'Nezadáno' }}
                <div v-if="lesson.feedback" class="mt-2">
                  <strong>Feedback:</strong><br>
                  <small class="text-muted">{{ lesson.feedback }}</small>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>



  </div>
</template>

<style scoped>
.lesson-item:last-child {
  border-bottom: none !important;
}

.btn{
  height:auto;
}

.card {
  box-shadow: 0 2px 4px rgba(0,0,0,0.1);
  border-radius: 8px;
}

/* Credit alerts */
.credit-alert-zero {
  background: linear-gradient(135deg, #dc3545 0%, #c82333 100%);
  color: white;
  border: none;
  border-radius: 12px;
  padding: 2rem;
  box-shadow: 0 4px 12px rgba(220, 53, 69, 0.3);
}

.credit-alert-zero h3 {
  color: white;
  font-weight: bold;
  margin: 0;
  font-size: 1.75rem;
}

.credit-alert-zero p {
  color: rgba(255, 255, 255, 0.95);
  font-size: 1.05rem;
}

.credit-alert-low {
  background: linear-gradient(135deg, #fff3cd 0%, #ffeaa7 100%);
  border: 2px solid #ffc107;
  border-radius: 10px;
  padding: 1.5rem;
  box-shadow: 0 3px 8px rgba(255, 193, 7, 0.2);
}

.credit-alert-low h5 {
  color: #856404;
  font-weight: 600;
  font-size: 1.2rem;
}

.credit-alert-low p {
  color: #856404;
}

/* Currency and Country Selector */
.currency-country-selector {
  display: flex;
  gap: 12px;
  justify-content: flex-end;
  margin-bottom: 16px;
}

.selector-group {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  min-width: 140px;
}

/* Compact Currency Selector for Top Card */
.currency-selector-compact {
  display: flex;
  align-items: center;
  gap: 12px;
  justify-content: flex-end;
}

.currency-selector-compact .selector-label {
  font-size: 0.95rem;
  font-weight: 600;
  margin: 0;
  color: #495057;
  white-space: nowrap;
}

.currency-selector-compact .form-select {
  width: auto;
  min-width: 150px;
  font-size: 1rem;
  padding: 0.5rem 0.75rem;
  border-radius: 8px;
  border: 2px solid #dee2e6;
  background-color: white;
  transition: all 0.2s ease-in-out;
  cursor: pointer;
}

.currency-selector-compact .form-select:hover {
  border-color: #80bdff;
}

.currency-selector-compact .form-select:focus {
  border-color: #0d6efd;
  outline: 0;
  box-shadow: 0 0 0 0.25rem rgba(13, 110, 253, 0.15);
}

.selector-label {
  font-size: 0.85rem;
  font-weight: 600;
  margin-bottom: 4px;
  color: #495057;
}

.form-select-sm {
  font-size: 0.875rem;
  padding: 0.375rem 0.75rem;
  border-radius: 6px;
  border: 1px solid #ced4da;
  background-color: white;
  transition: border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
}

.form-select-sm:focus {
  border-color: #80bdff;
  outline: 0;
  box-shadow: 0 0 0 0.2rem rgba(0, 123, 255, 0.25);
}

/* Buy credits buttons */
.btn-buy-credits-large {
  background: linear-gradient(135deg, #28a745 0%, #20c997 100%);
  color: white;
  font-size: 1.25rem;
  font-weight: bold;
  padding: 1rem 2.5rem;
  border: none;
  border-radius: 50px;
  box-shadow: 0 4px 12px rgba(40, 167, 69, 0.4);
  transition: all 0.3s ease;
  text-transform: uppercase;
  letter-spacing: 0.5px;
}

.credit-alert-low i {
  margin-right: 0.5rem;
}

/* Buy credits buttons */
.btn-buy-credits-large {
  background: linear-gradient(135deg, #28a745 0%, #20c997 100%);
  color: white;
  font-size: 1.25rem;
  font-weight: bold;
  padding: 1rem 2.5rem;
  border: none;
  border-radius: 50px;
  box-shadow: 0 4px 12px rgba(40, 167, 69, 0.4);
  transition: all 0.3s ease;
  text-transform: uppercase;
  letter-spacing: 0.5px;
}

.btn-buy-credits-large:hover {
  background: linear-gradient(135deg, #218838 0%, #1aa179 100%);
  box-shadow: 0 6px 16px rgba(40, 167, 69, 0.5);
  transform: translateY(-2px);
}

.btn-buy-credits-large i {
  margin-right: 0.5rem;
  font-size: 1.3rem;
}

.btn-buy-credits-medium {
  background: linear-gradient(135deg, #ffc107 0%, #ff9800 100%);
  color: #333;
  font-size: 1.1rem;
  font-weight: 600;
  padding: 0.75rem 2rem;
  border: none;
  border-radius: 30px;
  box-shadow: 0 3px 8px rgba(255, 193, 7, 0.3);
  transition: all 0.3s ease;
}

.btn-buy-credits-medium:hover {
  background: linear-gradient(135deg, #e0a800 0%, #e68900 100%);
  box-shadow: 0 4px 10px rgba(255, 193, 7, 0.4);
  transform: translateY(-1px);
}

.btn-buy-credits-small {
  background-color: #007bff;
  color: white;
  font-size: 0.95rem;
  font-weight: 500;
  padding: 0.6rem 1.5rem;
  border: none;
  border-radius: 20px;
  box-shadow: 0 2px 6px rgba(0, 123, 255, 0.2);
  transition: all 0.3s ease;
}

.btn-buy-credits-small:hover {
  background-color: #0056b3;
  box-shadow: 0 3px 8px rgba(0, 123, 255, 0.3);
  transform: translateY(-1px);
}

/* Credit display */
.credit-display {
  font-size: 1.3rem;
  font-weight: 600;
  color: #495057;
}

.credit-link {
  color: #007bff;
  text-decoration: none;
  cursor: pointer;
  padding: 4px 8px;
  border-radius: 5px;
  transition: all 0.2s ease;
  display: inline-block;
}

.credit-link:hover {
  color: #0056b3;
  background-color: #e7f3ff;
  text-decoration: underline;
}

/* Card improvements */
.card-body {
  padding: 1.5rem;
}

.card-body h5 {
  color: #333;
  font-weight: 600;
}

.border-info {
  border-color: #17a2b8 !important;
  border-width: 2px !important;
}

/* Orders table */
.table {
  margin-bottom: 0;
}

.table th {
  font-weight: 600;
  color: #495057;
  border-top: none;
}

.table td {
  vertical-align: middle;
}

.table-hover tbody tr:hover {
  background-color: #f8f9fa;
}

.badge {
  padding: 0.4rem 0.8rem;
  font-size: 0.85rem;
  font-weight: 500;
}

/* Card headers */
.card-header {
  padding: 1rem 1.5rem;
  font-weight: 600;
}

.card-header h5 {
  margin: 0;
  font-size: 1.1rem;
}

.bg-primary {
  background-color: #007bff !important;
}

.bg-info {
  background-color: #17a2b8 !important;
}

/* LL Lessons card */
.card .border-bottom:last-child {
  border-bottom: none !important;
}

/* Responsive adjustments */
@media (max-width: 768px) {
  .credit-alert-zero,
  .credit-alert-low {
    text-align: center;
  }
  
  .credit-alert-zero .col-md-4,
  .credit-alert-low .col-md-4,
  .card-body .col-md-4 {
    margin-top: 1rem;
    text-align: center !important;
  }
  
  .btn-buy-credits-large {
    width: 100%;
    font-size: 1.1rem;
    padding: 0.9rem 2rem;
  }
  
  .btn-buy-credits-medium {
    width: 100%;
  }
  
  .btn-buy-credits-small {
    width: 100%;
  }
}
</style>